import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import Categories from './pages/Categories/Categories';
import Product from './pages/Product/Product';
import Merchant from './pages/Merchant/Merchant';
import Buyer from './pages/Buyer/Buyer';
import Home from './pages/Website/home';
import Profile from './pages/Profile/Profile';
import WebsiteCategories from './pages/Website/categories';
import ComingSoon from './pages/Website/comingSoon';
import PrivacyPolicy from './pages/Website/privacyPolicy';
import SellerRegisterForm from './pages/SellerRegisterForm/SellerRegisterForm';
import ViewSeller from './pages/Website/viewSeller';
import SellerPage from './pages/Website/sellerPage';
import Brands from './pages/Brands/Brands';
import BrandsForAdmin from './pages/BrandsForAdmin/BrandsForAdmin';
import Analytics from './pages/Dashboard/Analytics';
import ViewProduct from './pages/viewProduct/viewProduct';

// ----------------------------------------------------------------------

export default function Router() {
  const role = sessionStorage.getItem("Role");
  const routes = useRoutes([
    role === "Seller"
      ? {
        path: "/seller",
        element: <DashboardLayout />,
        children: [
          { path: "app", element: <DashboardAppPage /> },
          { path: "brands", element: <Brands /> },
          { path: "brand/:brandid/product", element: <Product /> },
          { path: "profile", element: <Profile /> },
          { path: "buyer", element: <Buyer /> },
          { path: "brand/analytics/:id/:brandname", element: <Analytics /> },
        ],
      } : role === "Admin" ? {
        path: "/admin",
        element: <DashboardLayout />,
        children: [
          { path: "app", element: <DashboardAppPage /> },
          { path: "categories", element: <Categories /> },
          { path: "categories/:id", element: <Categories /> },
          { path: "product", element: <Product /> },
          { path: "seller", element: <Merchant /> },
          { path: "brands", element: <BrandsForAdmin /> },
          { path: "buyer", element: <Buyer /> },
          { path: "sellers/:sellerid/brands/:brandid/products", element: <ViewProduct /> },

        ],
      } : {
        path: "*",
        element: <Navigate to="/404" replace />
      },
    { path: "login", element: <LoginPage /> },
    { path: "seller/login", element: <LoginPage /> },
    { path: "buyer/login", element: <LoginPage /> },
    { path: "/categories", element: <WebsiteCategories /> },
    { path: "/search/seller/:id", element: <SellerPage /> },
    {
      children: [
        { element: <Navigate to="/comingsoon" />, index: true },
        { element: <Navigate to="/home" /> },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
        { path: "user", element: <UserPage /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
    { path: "home", element: <Home /> },
    { path: "comingsoon", element: <ComingSoon /> },
    { path: "seller-onboarding/:token", element: <SellerRegisterForm /> },
    { path: "forgot-password", element: <LoginPage /> },
    { path: "seller-password-reset/:token", element: <LoginPage /> },
    { path: "privacy-policy", element: <PrivacyPolicy /> },
  ]);

  return routes;
}
